export const Constants_empresa = {
  STATUS_OK: 200,
  STATUS_NOT_FOUND: 404,
  STATUS_CONFLICT: 409,
  STATUS_CREATED: 201,
  ID_JURIDICA: 6420,
  UNO: 1,
  ASC: 'asc',
  DESC: 'desc',
  TECNOLOGIAS: 'Tecnologias_Emergentes'
}
